module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css",
      "integrity": "sha384-xOolHFLEh07PJGoPkLv1IbcEPTNtaed2xpHsD9ESMhqIYd0nLMwNLD69Npy4HI+N",
      "crossorigin": "anonymous"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "name": "viewport",
      "content": "width=device-width, initial-scale=1, shrink-to-fit=no"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "graph card"
  }, [_vm._l((_vm.u.serials), function(serial, index) {
    return _c('li', {
      key: index,
      staticStyle: {
        "list-style-type": "none"
      }
    }, [_c('div', {
      staticClass: "col-12 px-0 mb-0"
    }, [_c('div', {
      staticClass: "col-12 px-0 pt-2"
    }, [_c('div', {
      staticClass: "col-md-6 row mx-0 px-0",
      staticStyle: {
        "background-color": "#0091a5",
        "font-size": "1.2em",
        "padding": "0.5em",
        "background-image": "linear-gradient(to bottom, #0091a5, #01889a, #027e90, #037585, #036c7b)"
      }
    }, [(serial.startsWith('KH1')) ? _c('div', {
      staticClass: "col-auto"
    }, [_c('img', {
      staticStyle: {
        "width": "30px"
      },
      attrs: {
        "src": require("../assets/KHA.png")
      }
    })]) : _vm._e(), _vm._v(" "), (serial.startsWith('CA1')) ? _c('div', {
      staticClass: "col-auto"
    }, [_c('img', {
      staticStyle: {
        "width": "30px"
      },
      attrs: {
        "src": require("../assets/CRA.png")
      }
    })]) : _vm._e(), _vm._v(" "), (serial.startsWith('KH2')) ? _c('div', {
      staticClass: "col-auto"
    }, [_c('img', {
      staticStyle: {
        "width": "40px"
      },
      attrs: {
        "src": require("../assets/KHApro.png")
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.u.name === 'default' || _vm.u.name === '123' || _vm.u.name === 'khacra') ? _c('div', {
      staticClass: "col px-0 align-self-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.lazy",
        value: (_vm.u.serials[index]),
        expression: "u.serials[index]",
        modifiers: {
          "lazy": true
        }
      }],
      attrs: {
        "maxlength": "12",
        "size": "10",
        "type": "text"
      },
      domProps: {
        "value": (_vm.u.serials[index])
      },
      on: {
        "change": function($event) {
          _vm.$set(_vm.u.serials, index, $event.target.value)
        }
      }
    })]) : (_vm.u.devname[index] != _vm.u.serials[index]) ? _c('div', {
      staticClass: "col px-0 text-white font-weight-bold align-self-center"
    }, [_vm._v(_vm._s(_vm.u.s_number[index]) + " " + _vm._s(_vm.u.devname[index]))]) : _c('div', {
      staticClass: "col px-0 text-white font-weight-bold align-self-center"
    }, [_vm._v(_vm._s(_vm.u.devname[index]))]), _vm._v(" "), _c('div', {
      staticClass: "col-auto"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "reset"
      },
      on: {
        "click": function($event) {
          _vm.fillData(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language]['refresh']))])])])]), _vm._v(" "), (!serial.startsWith('CA1')) ? _c('div', [_c('div', {
      staticClass: "col-12 px-0 pt-1 text-center "
    }, [_c('div', {
      staticClass: "col-md-6 row mx-0 p-3",
      staticStyle: {
        "background": "#f2f2f2"
      }
    }, [_c('div', {
      staticClass: "col border-right"
    }, [_c('div', {
      staticClass: "col-12 px-0"
    }, [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language]['khmeasure']) + "("), (_vm.u.tankKH[index] > 0) ? _c('span', {
      staticClass: "col-12 px-0 py-2 text-center",
      staticStyle: {
        "font-size": "0.8rem"
      }
    }, [_vm._v(_vm._s(_vm.u.timestamp[index]))]) : _vm._e(), _vm._v(")")]), _vm._v(" "), _c('div', {
      staticClass: "col-12 px-0"
    }, [(_vm.u.tankKH[index] > 0) ? _c('span', {
      staticClass: "font-weight-bold",
      staticStyle: {
        "font-size": "2.5rem"
      }
    }, [_vm._v(_vm._s(_vm.u.tankKH[index]))]) : _vm._e(), _vm._v("dKH")]), _vm._v(" "), _c('div', {
      staticClass: "col-12 px-0 text-center"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'kh-graph',
          params: {
            language: _vm.$route.params.language,
            sidx: index
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-primary",
      staticStyle: {
        "min-width": "110px"
      }
    }, [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language]['showkhgraph']))])])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "col"
    }, [(serial.startsWith('KH2') || _vm.u.ph1[index] !== -1) ? _c('div', [(_vm.u.phSignal[index] >= 100 && _vm.u.phSignal[index] < 1000) ? _c('div', {
      staticClass: "col-12 px-0"
    }, [_vm._v("PH")]) : _c('div', {
      staticClass: "col-12 px-0"
    }, [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language]['probelife']))]), _vm._v(" "), _c('div', {
      staticClass: "col-12 px-0 py-1"
    }, [(_vm.u.phSignal[index] >= 0 && _vm.u.phSignal[index] < 100) ? _c('span', {
      staticClass: "font-weight-bold",
      staticStyle: {
        "font-size": "2.5rem",
        "line-height": "3rem"
      }
    }, [_vm._v(_vm._s(_vm.u.phSignal[index]) + "%")]) : _vm._e(), _vm._v(" "), (_vm.u.phSignal[index] >= 100 && _vm.u.phSignal[index] < 1000) ? _c('span', {
      staticClass: "font-weight-bold",
      staticStyle: {
        "font-size": "2.5rem",
        "line-height": "3rem"
      }
    }, [_vm._v(_vm._s(_vm.u.phSignal[index] / 100))]) : _vm._e(), _vm._v(" "), (_vm.u.phSignal[index] >= 1000) ? _c('span', {
      staticClass: "font-weight-bold text-danger",
      staticStyle: {
        "font-size": "2.5rem",
        "line-height": "3rem"
      }
    }, [_vm._v("fail")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (serial.startsWith('KH1') && _vm.u.ph1[index] == -1) ? _c('div', [_c('div', {
      staticClass: "col-12 px-0 py-1"
    }, [(_vm.u.phSignal[index] >= 0 && _vm.u.phSignal[index] < 100) ? _c('span', {
      staticClass: "font-weight-bold",
      staticStyle: {
        "font-size": "2.5rem",
        "line-height": "3rem"
      }
    }, [_vm._v(_vm._s(_vm.u.phSignal[index]) + "%")]) : _vm._e(), _vm._v(" "), (_vm.u.phSignal[index] >= 100 && _vm.u.phSignal[index] < 1000) ? _c('span', {
      staticClass: "font-weight-bold",
      staticStyle: {
        "font-size": "2.5rem",
        "line-height": "3rem"
      }
    }, [_vm._v("100%")]) : _vm._e(), _vm._v(" "), (_vm.u.phSignal[index] >= 1000) ? _c('span', {
      staticClass: "font-weight-bold text-danger",
      staticStyle: {
        "font-size": "2.5rem",
        "line-height": "3rem"
      }
    }, [_vm._v("fail")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-12 px-0 text-center"
    }, [(_vm.u.phSignal[index] < 0) ? _c('span') : (_vm.u.phSignal[index] >= 100 && _vm.u.phSignal[index] < 1000) ? _c('span', [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language]['probemessage1']))]) : _c('span', {
      staticClass: "text-danger font-weight-bold"
    }, [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language]['changeprobe']))])]), _vm._v(" "), _c('div', {
      staticClass: "col-12 px-0 text-center"
    }, [(_vm.u.er_c[index] >= 5) ? _c('span', {
      staticClass: "text-danger font-weight-bold"
    }, [_vm._v("#" + _vm._s(_vm.u.er_pump[index]) + " " + _vm._s(_vm.nav[_vm.$route.params.language]['changepump']))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-12 px-0 pt-1 text-center "
    }, [_c('div', {
      staticClass: "col-md-6 row mx-0 p-3",
      staticStyle: {
        "background": "#f2f2f2"
      }
    }, [_c('div', {
      staticClass: "col border-right"
    }, [_c('div', {
      staticClass: "col-12 px-0"
    }, [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language]['targetkh']))]), _vm._v(" "), _c('div', {
      staticClass: "col-12 px-0"
    }, [_c('span', {
      staticClass: "font-weight-bold",
      staticStyle: {
        "font-size": "2.5rem"
      }
    }, [_vm._v(_vm._s(_vm.u.targetKH[index]))]), _vm._v("dKH")]), _vm._v(" "), _c('div', {
      staticClass: "col-12 px-0 text-center"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'kh-settings',
          params: {
            language: _vm.$route.params.language,
            sidx: index
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-primary",
      staticStyle: {
        "min-width": "110px"
      }
    }, [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language]['targetset']))])])], 1)]), _vm._v(" "), (serial.startsWith('KH1')) ? _c('div', {
      staticClass: "col"
    }, [(_vm.u.trueKH[index] == 0) ? _c('div', {
      staticClass: "col-12 px-0"
    }, [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language]['calibration']))]) : _vm._e(), _vm._v(" "), (_vm.u.trueKH[index] > 0) ? _c('div', {
      staticClass: "col-12 px-0 text-danger font-weight-bold"
    }, [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language]['nextcalib']))]) : _vm._e(), _vm._v(" "), (_vm.u.trueKH[index] == 0) ? _c('div', {
      staticClass: "col-12 px-0 py-1"
    }, [_c('img', {
      attrs: {
        "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAADtElEQVR4nO2aW0tUURiGH6hs7izQKTLTLrOLzhAElR3+RmiYQQXdFdLBICr7CUEHO0Op/YfUIoisuw6OZmGHm8pKMygnFrwbFtM4e609e89o+cJmmNnvOnz7O65vD8zBGVldsx7ZOUHKhHnAOuAgcKOARm6Is1ZjZgxqgFPAR2vT9san+57VmA5gJWXESqAb+G1tLAN0As0FBGkWJ2PdM3N0AfWlFGABcBj4pk1MAneALRGcfQNwARgXZ0LaXUjCWAI80qJTwBUgHUPUMvNe1ZyG+8Bh3shYDQxroUFgWwLhtxEYEt98NpCAEJ+1QC9QlWAeqQb6NeZTnMIstTTRFcF+oyTEFNBjacaYXlFYaPlEb0QnjJrZU5ZmHgIVFIFjlk/4mFNcJUq1FabbiskTE4okWz3GLQZaCwiyD1jkMV+j9jAeNc8ENnrZkW/Mrh346pDZx4CTHuZy1fJRb238lkaMesOwAnhmbbqvgCB91m8DQK3D/GngB/ALqPMR5JwWuuQoxFvxh2UKYT6yA3it398Ayx3W6RT/jKsQ860CcL2DOT21tFDl4ezVyuDm3hMHM9sk7gfXqnm9Brx04LZbmogS1YwwI5rjuAN/UFxzXAjFIZEvOkSnMXG3Ex07NccXoDKEe1lcc54JxW2R94Tw9lsFXrG4r7laQnhN4t2ihDA2fx4Y1XVWR4BZh46c02BWuSNRZGO6bLzLc/9F0utmExBkNM/95yV4gP+GaSXl7B3ldPZbenom1BVCa4zht9cx/O4Vz+6bhSbEsDprkZUQc+srH+z2SIid4h7wKVFeOXBPiPs6YomS9ixRhsVd41s0bnTwgwFx+6cp+V2KxscO/rNZ3Pc+rdazGmT6VmGoVSme1dPd5SDITksTI2q7huG6+KfxQL0OVj8cG2W1KsWzlnamEyRw7EATNY6dnEkdrMz5xwvdWswcM11QIZ/5krPxXEECxz7mEY6va5xpzXqjXgf+Kc8yvTInjOYK0uIQnfKV+d+jaCNAmybJOJ7d86GYMiJtRaojFIEKNccCuzdNs1IJkrKiWl8cVUHaaiz3RBAmiiAp4F4M1vAXGtRQLpQv4hIkbWnCrLmKmNFgaSbjUZb4CLLD8olMEkLYTyvwGRPNrinGFyvIEs01FVHrsbx6+6n4npvRo7x6G9ert6I6774wrcu7yrbBZoccXoY2qfSxX4b+0lx1lBHLgKNW2zRfJs/3Pegalv31dC7mqbwO+8PATZ15ZtwfBsJQkgZBKTAnyH+JP9RewEUWCMmeAAAAAElFTkSuQmCC"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.u.trueKH[index] > 0) ? _c('div', {
      staticClass: "col-12 px-0 font-weight-bold",
      staticStyle: {
        "font-size": "2.5rem"
      }
    }, [_vm._v(_vm._s(_vm.u.trueKH[index].toFixed(2)))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-12 px-0 text-center"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'kh-calibration',
          params: {
            language: _vm.$route.params.language,
            sidx: index
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-primary",
      staticStyle: {
        "min-width": "110px"
      }
    }, [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language]['calibrate']))])])], 1)]) : _vm._e(), _vm._v(" "), (serial.startsWith('KH2')) ? _c('div', {
      staticClass: "col"
    }, [(_vm.u.trueKH[index] == 0) ? _c('div', {
      staticClass: "col-12 px-0"
    }, [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language]['calibration']))]) : _vm._e(), _vm._v(" "), (_vm.u.trueKH[index] > 0) ? _c('div', {
      staticClass: "col-12 px-0 text-danger font-weight-bold"
    }, [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language]['nextcalib']))]) : _vm._e(), _vm._v(" "), (_vm.u.trueKH[index] == 0) ? _c('div', {
      staticClass: "col-12 px-0 py-1"
    }, [_c('img', {
      attrs: {
        "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAADtElEQVR4nO2aW0tUURiGH6hs7izQKTLTLrOLzhAElR3+RmiYQQXdFdLBICr7CUEHO0Op/YfUIoisuw6OZmGHm8pKMygnFrwbFtM4e609e89o+cJmmNnvOnz7O65vD8zBGVldsx7ZOUHKhHnAOuAgcKOARm6Is1ZjZgxqgFPAR2vT9san+57VmA5gJWXESqAb+G1tLAN0As0FBGkWJ2PdM3N0AfWlFGABcBj4pk1MAneALRGcfQNwARgXZ0LaXUjCWAI80qJTwBUgHUPUMvNe1ZyG+8Bh3shYDQxroUFgWwLhtxEYEt98NpCAEJ+1QC9QlWAeqQb6NeZTnMIstTTRFcF+oyTEFNBjacaYXlFYaPlEb0QnjJrZU5ZmHgIVFIFjlk/4mFNcJUq1FabbiskTE4okWz3GLQZaCwiyD1jkMV+j9jAeNc8ENnrZkW/Mrh346pDZx4CTHuZy1fJRb238lkaMesOwAnhmbbqvgCB91m8DQK3D/GngB/ALqPMR5JwWuuQoxFvxh2UKYT6yA3it398Ayx3W6RT/jKsQ860CcL2DOT21tFDl4ezVyuDm3hMHM9sk7gfXqnm9Brx04LZbmogS1YwwI5rjuAN/UFxzXAjFIZEvOkSnMXG3Ex07NccXoDKEe1lcc54JxW2R94Tw9lsFXrG4r7laQnhN4t2ihDA2fx4Y1XVWR4BZh46c02BWuSNRZGO6bLzLc/9F0utmExBkNM/95yV4gP+GaSXl7B3ldPZbenom1BVCa4zht9cx/O4Vz+6bhSbEsDprkZUQc+srH+z2SIid4h7wKVFeOXBPiPs6YomS9ixRhsVd41s0bnTwgwFx+6cp+V2KxscO/rNZ3Pc+rdazGmT6VmGoVSme1dPd5SDITksTI2q7huG6+KfxQL0OVj8cG2W1KsWzlnamEyRw7EATNY6dnEkdrMz5xwvdWswcM11QIZ/5krPxXEECxz7mEY6va5xpzXqjXgf+Kc8yvTInjOYK0uIQnfKV+d+jaCNAmybJOJ7d86GYMiJtRaojFIEKNccCuzdNs1IJkrKiWl8cVUHaaiz3RBAmiiAp4F4M1vAXGtRQLpQv4hIkbWnCrLmKmNFgaSbjUZb4CLLD8olMEkLYTyvwGRPNrinGFyvIEs01FVHrsbx6+6n4npvRo7x6G9ert6I6774wrcu7yrbBZoccXoY2qfSxX4b+0lx1lBHLgKNW2zRfJs/3Pegalv31dC7mqbwO+8PATZ15ZtwfBsJQkgZBKTAnyH+JP9RewEUWCMmeAAAAAElFTkSuQmCC"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.u.trueKH[index] == 1.23) ? _c('div', {
      staticClass: "col-12 px-0 font-weight-bold py-1",
      staticStyle: {
        "font-size": "2.0rem"
      }
    }, [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language]['calliquid']))]) : (_vm.u.trueKH[index] > 0) ? _c('div', {
      staticClass: "col-12 px-0 font-weight-bold",
      staticStyle: {
        "font-size": "2.5rem"
      }
    }, [_vm._v(_vm._s(_vm.u.trueKH[index].toFixed(2)))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-12 px-0 text-center"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'kh-calibration',
          params: {
            language: _vm.$route.params.language,
            sidx: index
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-primary",
      staticStyle: {
        "min-width": "110px"
      }
    }, [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language]['calibrate']))])])], 1)]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-12 px-0 pt-1 text-center"
    }, [_c('div', {
      staticClass: "col-md-6 row mx-0 p-3",
      staticStyle: {
        "background": "#f2f2f2"
      }
    }, [_c('div', {
      staticClass: "col border-right"
    }, [(_vm.u.KHRemain[index] < _vm.u.mlspec[index]) ? _c('div', {
      staticClass: "col-12 px-0 text-center text-danger font-weight-bold",
      staticStyle: {
        "font-size": "1rem"
      }
    }, [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language]['refillsolution']))]) : _c('div', {
      staticClass: "col-12 px-0"
    }, [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language]['dosingsolution']))]), _vm._v(" "), (_vm.u.KHRemain[index] < 10000) ? _c('div', {
      staticClass: "col-12 px-0 py-1"
    }, [_c('span', {
      staticClass: "font-weight-bold",
      staticStyle: {
        "font-size": "2.5rem",
        "line-height": "3rem"
      }
    }, [_vm._v(_vm._s(_vm.u.KHRemain[index]))]), _vm._v("ml")]) : _c('div', {
      staticClass: "col-12 px-0 py-1"
    }, [_c('span', {
      staticClass: "font-weight-bold",
      staticStyle: {
        "font-size": "2.0rem",
        "line-height": "3rem"
      }
    }, [_vm._v(_vm._s(_vm.u.KHRemain[index]))]), _vm._v("ml")]), _vm._v(" "), _c('div', {
      staticClass: "col-12 px-0 text-center"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'kh-dosing',
          params: {
            language: _vm.$route.params.language,
            sidx: index
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-primary",
      staticStyle: {
        "min-width": "110px"
      }
    }, [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language]['setup']))])])], 1)]), _vm._v(" "), (serial.startsWith('KH2')) ? _c('div', {
      staticClass: "col"
    }, [(_vm.u.CalRemain[index] < _vm.u.mlspec[index]) ? _c('div', {
      staticClass: "col-12 px-0 text-center text-danger font-weight-bold",
      staticStyle: {
        "font-size": "1rem"
      }
    }, [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language]['refillcalsolution']))]) : _c('div', {
      staticClass: "col-12 px-0"
    }, [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language]['calsolution']))]), _vm._v(" "), _c('div', {
      staticClass: "col-12 px-0 py-1"
    }, [_c('span', {
      staticClass: "font-weight-bold",
      staticStyle: {
        "font-size": "2.5rem",
        "line-height": "3rem"
      }
    }, [_vm._v(_vm._s(_vm.u.CalRemain[index]))]), _vm._v("ml")]), _vm._v(" "), _c('div', {
      staticClass: "col-12 px-0 text-center"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'kh-calsolution',
          params: {
            language: _vm.$route.params.language,
            sidx: index
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-primary",
      staticStyle: {
        "min-width": "110px"
      }
    }, [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language]['setup']))])])], 1)]) : _c('div', {
      staticClass: "col"
    })])])]) : _vm._e(), _vm._v(" "), (serial.startsWith('CA1')) ? _c('div', [_c('div', {
      staticClass: "col-12 px-0 pt-1 text-center"
    }, [_c('div', {
      staticClass: "col-md-6 row mx-0 p-3",
      staticStyle: {
        "background": "#f2f2f2"
      }
    }, [_c('div', {
      staticClass: "col border-right"
    }, [_c('div', {
      staticClass: "col-12 px-0"
    }, [_vm._v("Δ" + _vm._s(_vm.nav[_vm.$route.params.language]['kherror']))]), _vm._v(" "), _c('div', {
      staticClass: "col-12 px-0 py-2 text-center",
      staticStyle: {
        "font-size": "0.8rem"
      }
    }, [_vm._v("(" + _vm._s(_vm.u.timestamp[index]) + ")")]), _vm._v(" "), (_vm.u.tankKH[index] < 0) ? _c('div', {
      staticClass: "col-12 px-0"
    }, [_c('span', {
      staticClass: "font-weight-bold",
      staticStyle: {
        "font-size": "2.5rem"
      }
    }, [_vm._v(_vm._s(_vm.u.tankKH[index] * -1))]), _vm._v("dKH")]) : _c('div', {
      staticClass: "col-12 px-0"
    }, [_c('span', {
      staticClass: "font-weight-bold",
      staticStyle: {
        "font-size": "2.0rem"
      }
    }, [_vm._v(_vm._s(_vm.u.tankKH[index] * -1))]), _vm._v("dKH")]), _vm._v(" "), _c('div', {
      staticClass: "col-12 px-0 text-center"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'CaRx-graph',
          params: {
            language: _vm.$route.params.language,
            sidx: index
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-primary",
      staticStyle: {
        "min-width": "110px"
      }
    }, [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language]['showkhgraph']))])])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "col"
    }, [_c('div', {
      staticClass: "col-12 px-0"
    }, [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language]['CAsetting']))]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "col-12 px-0 text-center"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'CaRx-settings',
          params: {
            language: _vm.$route.params.language,
            sidx: index
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-primary",
      staticStyle: {
        "min-width": "110px"
      }
    }, [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language]['targetset']))])])], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.u.name === 'default' || _vm.u.name === '123' || _vm.u.name === 'khacra') ? _c('div', {
      staticClass: "col-12 px-0 pt-1 text-center "
    }, [_c('fieldset', {
      staticClass: "col-md-6",
      staticStyle: {
        "background-color": "#81cb07",
        "font-size": "1em",
        "padding": "0.3em",
        "border-radius": "0.2em"
      }
    }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language]['aiadvisor']))])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('button', {
      staticClass: "btn btn-primary",
      staticStyle: {
        "height": "25pt",
        "padding": "2pt"
      },
      attrs: {
        "type": "reset"
      },
      on: {
        "click": function($event) {
          _vm.addMsg(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language]['upload']))])]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.u.message_dev[index]),
        expression: "u.message_dev[index]"
      }],
      staticClass: "form-control",
      attrs: {
        "rows": "1",
        "placeholder": "add comments to show to device owner"
      },
      domProps: {
        "value": (_vm.u.message_dev[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.u.message_dev, index, $event.target.value)
        }
      }
    })])]) : _c('div', {
      staticClass: "col-12 px-0 pt-1  "
    }, [(_vm.u.message_dev[index] !== '') ? _c('fieldset', {
      staticClass: "col-md-6",
      staticStyle: {
        "background-color": "#81cb07",
        "font-size": "1em",
        "padding": "0.3em",
        "border-radius": "0.2em"
      }
    }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language]['aiadvisor']))])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('button', {
      staticClass: "btn btn-primary",
      staticStyle: {
        "height": "25pt",
        "padding": "2pt"
      },
      attrs: {
        "type": "reset"
      },
      on: {
        "click": function($event) {
          _vm.clearMsg(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language]['igotit']))])]), _vm._v(" "), _c('p', {
      staticClass: "form-control"
    }, [_vm._v(_vm._s(_vm.u.message_dev[index]))])]) : _vm._e()])])])
  }), _vm._v(" "), _vm._m(1)], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 px-0 py-1",
    staticStyle: {
      "line-height": "4rem"
    }
  }, [_c('img', {
    attrs: {
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAADMklEQVR4nNWa34tNURTHPzKiSaZomDQNpkGuB6VGKcqv8uAVr4R/YNQ8STxoROGBTFLi2ZOMpLxo/KhJiDEz5UG5fuTBVWqGXOZqZ506ndnnnP3r3DnzrfVwb/uutb577/Vj730hLM4Cf4FGQv4A/cwhfNSQiOQFcwRLgOkMIj+B+cwBbM0gEcn62XSwCzgOtOeMO2pA5ECOjnaxpWwGxWrgvTjxFdiXMfaCAZHTGb/fBXyScVWgJxSJHlEYd0TFwEVgYWLsMuCZAZGHwOLEbxcA5zTZrhqCjI5EXF4BFWAbcAf4bUAikkngFrBR7IxkjK36kOnMIRFJ3cJ5nagVmDIYVxWfrHHY08Ei5JALkVZgogTON0TeaeLKGJst931RUge24IlTJSByggBoMUypRcmTkC3N2gDZyUWmgG4CYqejI6PAXZG3jqm5EpLIfQvjKjlcBlaltDpXLFf3RigSHXIgMjH6DdhhuMI1Q50/pBRYo01a8WPST41YrIQJiXhzaLoyj4DzwBFJw+rMk3k8NWlJ0kRtJ1tc9bD3ARjQKdWdsU1lOiUm8rDGw2ZDfJ4BH4UqO7lizNP2DPgoU+nVFUNlIjLkQeRemYiMlmlr1T0VqmJni25Pm3Wd0n65PPvlqFRVbFsMevRgz4G+vG53A3AQOAMMW8yOqtim2GOxCx7Izct+YJ1rN7zcwmBNKnYedgPfLXQuIhBsUmRdKrYqdrqYGCzgSFADrpkchbc7GhiTSVAyHtj5hkYUmUxUCpjFXsKhN9Z9p0LdJr5swmyGklRcKoFzDV8ie3PeOgqZuVi2zLv5jyNVr1LyeTa2AP9PpSpRvLYgk6q3r0lboEVDYlzGjMnKeBHpMjwxurY0CvOAm8B1eVaIkxiXz6bIXOm8Z4WnMkalv9uWpKK0Phl7M3ElgcmW1ZFRFw0nNdtiqZCz2VpqEr7Evo9IBAv2NDITOcXM5OktaVCd99/ESHSEDPYkOuXNpDXAY6gu2NU11Ioigr3I5+mmB7sL2gyLaNODPfRfOJIGNyWSiYrBlQ42CyEyYHDhlxXslIWIi8Eo2EPrLQxFGWzMFpGihGbhcYEkhv8BZG3QcBC3xlMAAAAASUVORK5CYII="
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("v1.53")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8bb31d5c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/My_KH.vue
// module id = 532
// module chunks = 0